var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      !_vm.horizontal
        ? [
            _c("h2", [_vm._v("Quick Look")]),
            _c("p", [_vm._v("Horizon: " + _vm._s(_vm.horizon) + " years")]),
            _vm.yearlyValues.length
              ? _c("h3", [
                  _vm._v(
                    " First Year " +
                      _vm._s(
                        _vm.yearlyValues[0].year
                          ? "(" + _vm.yearlyValues[0].year + ")"
                          : ""
                      ) +
                      " "
                  ),
                ])
              : _vm._e(),
            _vm._l(_vm.firstYear.values, function (item, i) {
              return _c("p", { key: i + "," + item }, [
                _vm._v(
                  " " +
                    _vm._s(item.title) +
                    ": " +
                    _vm._s(item.value) +
                    " " +
                    _vm._s(item.suffix) +
                    " "
                ),
              ])
            }),
            _c("h3", [
              _vm._v(
                " Last Year " +
                  _vm._s(
                    _vm.lastYear.year ? "(" + _vm.lastYear.year + ")" : ""
                  ) +
                  " "
              ),
            ]),
            _vm._l(_vm.lastYear.values, function (item, i) {
              return _c("p", { key: "l-" + i + "," + item }, [
                _vm._v(
                  " " +
                    _vm._s(item.title) +
                    ": " +
                    _vm._s(item.value) +
                    " " +
                    _vm._s(item.suffix) +
                    " "
                ),
              ])
            }),
            _c("v-select", {
              attrs: {
                items: _vm.dropdownItem,
                "item-text": "text",
                "item-value": "value",
                filled: "",
                label: "Select Year",
                "return-object": "",
              },
              model: {
                value: _vm.selectedYear,
                callback: function ($$v) {
                  _vm.selectedYear = $$v
                },
                expression: "selectedYear",
              },
            }),
            _vm.selectedYear
              ? [
                  _c("h3", [_vm._v(_vm._s(_vm.selectedYear.text))]),
                  _vm._l(_vm.selectedYear.value, function (item, index) {
                    return _c("p", { key: "s + " + index + "," + item }, [
                      _vm._v(
                        " " +
                          _vm._s(item.title) +
                          ": " +
                          _vm._s(item.value) +
                          " " +
                          _vm._s(item.suffix) +
                          " "
                      ),
                    ])
                  }),
                ]
              : _vm._e(),
          ]
        : [
            _c(
              "v-row",
              [
                _c("v-col", { attrs: { cols: "6", sm: "2", md: "2" } }, [
                  _c("h2", [_vm._v("Quick Look")]),
                  _c("p", [
                    _vm._v("Horizon: " + _vm._s(_vm.horizon) + " years"),
                  ]),
                  _vm.date
                    ? _c("p", { staticClass: "text-caption" }, [
                        _vm._v(_vm._s(_vm.date)),
                      ])
                    : _vm._e(),
                ]),
                _c("v-spacer"),
                _c(
                  "v-col",
                  { attrs: { cols: "6", sm: "2", md: "2" } },
                  [
                    _c("v-select", {
                      attrs: {
                        items: _vm.dropdownItem,
                        "item-text": "text",
                        "item-value": "value",
                        filled: "",
                        label: "Select Year",
                        "return-object": "",
                      },
                      model: {
                        value: _vm.selectedYear,
                        callback: function ($$v) {
                          _vm.selectedYear = $$v
                        },
                        expression: "selectedYear",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "v-row",
              [
                _c(
                  "v-col",
                  [
                    _vm.yearlyValues.length
                      ? _c("h3", [
                          _vm._v(
                            " First Year " +
                              _vm._s(
                                _vm.yearlyValues[0].year
                                  ? "(" + _vm.yearlyValues[0].year + ")"
                                  : ""
                              ) +
                              " "
                          ),
                        ])
                      : _vm._e(),
                    _vm._l(_vm.firstYear.values, function (item, i) {
                      return _c("p", { key: i + "," + item }, [
                        _vm._v(
                          " " +
                            _vm._s(item.title) +
                            ": " +
                            _vm._s(item.value) +
                            " " +
                            _vm._s(item.suffix) +
                            " "
                        ),
                      ])
                    }),
                  ],
                  2
                ),
                _c(
                  "v-col",
                  [
                    _c("h3", [
                      _vm._v(
                        " Last Year " +
                          _vm._s(
                            _vm.lastYear.year
                              ? "(" + _vm.lastYear.year + ")"
                              : ""
                          ) +
                          " "
                      ),
                    ]),
                    _vm._l(_vm.lastYear.values, function (item, i) {
                      return _c("p", { key: "l-" + i + "," + item }, [
                        _vm._v(
                          " " +
                            _vm._s(item.title) +
                            ": " +
                            _vm._s(item.value) +
                            " " +
                            _vm._s(item.suffix) +
                            " "
                        ),
                      ])
                    }),
                  ],
                  2
                ),
                _c(
                  "v-col",
                  [
                    _vm.selectedYear
                      ? [
                          _c("h3", [_vm._v(_vm._s(_vm.selectedYear.text))]),
                          _vm._l(
                            _vm.selectedYear.value,
                            function (item, index) {
                              return _c(
                                "p",
                                { key: "s + " + index + "," + item },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(item.title) +
                                      ": " +
                                      _vm._s(item.value) +
                                      " " +
                                      _vm._s(item.suffix) +
                                      " "
                                  ),
                                ]
                              )
                            }
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }